import React from "react";
import "./Header.css"

function Header() {
  return (
    <div>
      <div className="header-section">
        <div className="container">
          <div className="row">
            <div className="col-12">
              <h3>Freshness at Your Fingertips...</h3>
              <p>
                Enjoy the convenience of online shopping <br/> and the assurance of
                fresh, top-quality <br/> products every time. Experience <br/> AgroMobile
                today!
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default Header;
